<div class="w-12 flex-x flex-l flex-middle flex-justify-end height-100">
    <div class="w-12 flex-column-m flex-column-s p-t-3-m p-t-3-s search-content-block">
        <div class="w-12 flex p-r-4-m p-l-4-m p p-l-4-s">
            <search [searchId]="'header'"
                    [content]="content"
                    (focusChange)="onFocusChange($event)"></search>
        </div>
    </div>
</div>